import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { FirebaseAuthProvider } from './contexts/FirebaseAuthContext';
import AppShell from './components/AppShell';
import { ServiceProvider } from './contexts/ServiceContext';
import { ImageProvider } from './contexts/ImageContext';
import { ProductProvider } from './contexts/ProductContext';
import { BrandProvider } from './contexts/BrandContext';
import { ConsultationProvider } from './contexts/ConsultationContext';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import Minimal from './pages/Minimal';
import Oaken from './pages/Oaken';
import Modernist from './pages/Modernist';
import Lumen from './pages/Lumen';
import Arbor from './pages/Arbor';
import VirtualTour from './pages/VirtualTour';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminSettings from './pages/AdminSettings';
import AdminLeads from './pages/AdminLeads';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <FirebaseAuthProvider>
    <ServiceProvider>
      <ImageProvider>
        <ProductProvider>
          <BrandProvider>
            <ConsultationProvider>
              <Router>
                <div className="min-h-screen bg-surface text-on-surface">
                  <AppShell>
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/about" element={<About />} />
                      <Route path="/services" element={<Services />} />
                      <Route path="/gallery" element={<Gallery />} />
                      <Route path="/contact" element={<Contact />} />
                      <Route path="/minimal" element={<Minimal />} />
                      <Route path="/oaken" element={<Oaken />} />
                      <Route path="/modernist" element={<Modernist />} />
                      <Route path="/lumen" element={<Lumen />} />
                      <Route path="/arbor" element={<Arbor />} />
                      <Route path="/virtual-tour" element={<VirtualTour />} />
                      <Route path="/admin/login" element={<AdminLogin />} />
                      <Route
                        path="/admin/dashboard"
                        element={<Navigate to="/dashboard" replace />}
                      />
                      <Route
                        path="/admin"
                        element={
                          <ProtectedRoute>
                            <Navigate to="/admin/leads" replace />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/admin/leads"
                        element={
                          <ProtectedRoute>
                            <AdminLeads />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/dashboard"
                        element={
                          <ProtectedRoute>
                            <AdminDashboard />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/admin/settings"
                        element={
                          <ProtectedRoute>
                            <AdminSettings />
                          </ProtectedRoute>
                        }
                      />
                    </Routes>
                  </AppShell>
                </div>
              </Router>
            </ConsultationProvider>
          </BrandProvider>
        </ProductProvider>
      </ImageProvider>
    </ServiceProvider>
    </FirebaseAuthProvider>
  );
}

export default App;
